export const getSetting = key => {
  return (window.config && window.config[key]) || process.env[key];
};

export const REACT_APP_APPLICATION_PROFILE = getSetting('REACT_APP_APPLICATION_PROFILE');
export const REACT_APP_CLIENT_ID = getSetting('REACT_APP_CLIENT_ID');
export const REACT_APP_AUTOMASJON_API_URL = getSetting('REACT_APP_AUTOMASJON_API_URL');
